import { render, staticRenderFns } from "./CrmCampos.vue?vue&type=template&id=34a80b82"
import script from "./CrmCampos.vue?vue&type=script&lang=js"
export * from "./CrmCampos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports